module.exports = __webpack_public_path__ + "img/wanglifen.ae93618b.png";